// extracted by mini-css-extract-plugin
export var deleteModal = "_fs-0";